export default class ProductPagesService {
  constructor(Api) {
    "ngInject"
    this.api = Api;

  }

  loadCategories(data) {
    return this.api.call({
      method: 'get',
      url: '/productPage/categories/' + data.parentId + '/' + data.currentPage + '/' + data.pageLimit + '/' + data.field + '/' + data.order_type
    })
  }

  loadCategoriesNoLimit(parentId) {
    return this.api.call({
      method: 'get',
      url: '/productPage/categoriesNoLimit/' + parentId
    })
  }

  getProductPage(id, type) {
    return this.api.call({
      method: 'get',
      url: '/productPage/get/' + id + '/' + type
    })
  }

  getProductPageProducts(id, type) {
    return this.api.call({
      method: 'get',
      url: '/productPage/products/' + id + '/' + type
    })
  }

  saveProductPage(data) {
    let
      url = '/productPage/saveProductPage';
    return this.api.call({
      method: 'post',
      url,
      data: data,
      headers: {
        "Content-Type": 'application/json'
      }
    })
  }

  updateProductPage(data, type) {
    let
      url = '/productPage/updateProductPage/' + type;
    return this.api.call({
      method: 'put',
      url,
      data: data,
      headers: {
        "Content-Type": 'application/json'
      }
    })
  }

  loadProductPages(data, type) {
    return this.api.call({
      method: 'get',
      url: '/productPage/list/' + data.categoryId + '/' + data.subCategoryId + '/' + data.currentPage + '/' + data.pageLimit + '/' + type + '/' + data.field + '/' + data.order_type
    })
  }

  saveCategory(data) {
    let
      url = '/productPage/saveCategory';
    return this.api.call({
      method: 'post',
      url,
      data: data,
      headers: {
        "Content-Type": 'application/json'
      }
    })
  }

  updateCategoryOrder(data) {
    let
      url = '/productPage/updateCategoryOrder'
    return this.api.call({
      method: 'post',
      url,
      data: data,
      headers: {
        "Content-Type": 'application/json'
      }
    })
  }

  updateProductPageOrder(data) {
    let
      url = '/productPage/updateProductPageOrder'
    return this.api.call({
      method: 'post',
      url,
      data: data,
      headers: {
        "Content-Type": 'application/json'
      }
    })
  }

  removeCategory(id, type) {
    let
      url = `/productPage/removeCategory/${id}/${type}`;
    return this.api.call({
      method: 'delete',
      url
    })
  }

  categoryById(id) {
    return this.api.call({
      method: 'get',
      url: '/productPage/category/' + id
    })
  }

  updateCategory(data) {
    let
      url = '/productPage/updateCategory';
    return this.api.call({
      method: 'post',
      url,
      data: data,
      headers: {
        "Content-Type": 'application/json'
      }
    })
  }

  getSubCategory(data) {
    return this.api.call({
      method: 'get',
      url: '/productPage/getSubCategory/' + data.parentId + '/' + data.currentPage + '/' + data.pageLimit + '/' + data.field + '/' + data.order_type
    })
  }

  updateProductPageStatus(data) {
    let
      url = '/productPage/updateStatus';
    return this.api.call({
      method: 'post',
      url,
      data: data,
      headers: {
        "Content-Type": 'application/json'
      }
    })
  }

  removeProductPage(id) {
    let
      url = `/productPage/removeProductPage/${id}`;
    return this.api.call({
      method: 'delete',
      url
    })
  }

  removeProduct(id, apid) {
    let
      url = `/productPage/removeProduct/${id}/${apid}`;
    return this.api.call({
      method: 'delete',
      url
    })
  }

}


// WEBPACK FOOTER //




/** WEBPACK FOOTER **
 ** C:/Users/larss/Documents/signlabs-admin-frontend/client/app/modules/product-page/services/products.pages.service.js
 **/